import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import z from 'zod';
import { PlatformProfilePrivilegesParameters } from '@mews-commander/data-access';
import { PlatformProfilePrivilegesFlag } from '../Common/privilegesUtils';
import { PlatformProfilesRole } from './RoleField';

export enum FieldNames {
    Emails = 'emails',
    Role = 'role',
    Privileges = 'privileges',
}

export interface CommonPlatformProfileFormData {
    [FieldNames.Role]: PlatformProfilesRole;
    [FieldNames.Privileges]: PlatformProfilePrivilegesFlag[];
}

export const platformProfilesCommonValidationSchema = z.discriminatedUnion(FieldNames.Role, [
    z.object({
        [FieldNames.Role]: z.enum([PlatformProfilesRole.Admin]),
    }),
    z.object({
        [FieldNames.Role]: z.enum([PlatformProfilesRole.Support, PlatformProfilesRole.Developer]),
        [FieldNames.Privileges]: z.array(z.string()).min(1),
    }),
]);

export const parsePlatformProfilePrivilegesToApiPayload = (
    role: PlatformProfilesRole,
    privileges: PlatformProfilePrivilegesFlag[]
) => {
    if (role === PlatformProfilesRole.Admin) {
        return {};
    }

    return pipe(
        privileges,
        array.map((privilege) => [privilege, true]),
        Object.fromEntries
    );
};

export const parsePlatformProfileCommonFormDataToPayload = ({
    privileges,
    role,
}: CommonPlatformProfileFormData): {
    isAdmin: boolean;
    privileges: PlatformProfilePrivilegesParameters;
} => ({
    isAdmin: role === PlatformProfilesRole.Admin,
    privileges: parsePlatformProfilePrivilegesToApiPayload(role, privileges),
});
